import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("../pages/landingPage.vue"),
    },
    {
      path: "/signup",
      name: "signup",
      meta: { forVisitors: true },
      component: () => import("../pages/SignUpPage.vue"),
    },
    {
      path: "/login",
      name: "login",
      meta: { forVisitors: true },
      component: () => import("../pages/LoginPage"),
    },
    {
      path: "/contact-us",
      name: "ContactUs",
      meta: { forVisitors: true },
      component: () => import("../pages/ContactUs"),
    },
    {
      path: "/terms",
      name: "PrivacyAndTerms",
      meta: { forVisitors: true },
      component: () => import("../pages/PrivacyAndTerms"),
    },
    {
      path: "/deleteaccount",
      name: "DeleteAccount",
      meta: { forVisitors: true },
      component: () => import("../pages/DeleteAccount"),
    },
    {
      path: "/dashboard",
      name: "dashboard",
      meta: { forAuth: true },
      component: () => import("../pages/Dashboard"),
      children: [
        {
          path: "/",
          name: "dashboard",
          component: () => import("../pages/DashboardHome"),
        },
        {
          path: "/dashboard/Transfer",
          name: "transfer",
          component: () => import("../pages/Transfer"),
        },
        {
          path: "/dashboard/AirTime",
          name: "airTime",
          component: () => import("../pages/AirTime"),
        },
        {
          path: "/dashboard/Cable",
          name: "cable",
          component: () => import("../pages/Cable"),
        },
        {
          path: "/dashboard/Internet",
          name: "internet",
          component: () => import("../pages/Internet"),
        },
        {
          path: "/dashboard/Frsc",
          name: "frsc",
          component: () => import("../pages/Frsc"),
        },
        {
          path: "/dashboard/Nis",
          name: "nis",
          component: () => import("../pages/Nis"),
        },
        {
          path: "/dashboard/Electricity",
          name: "electricity",
          component: () => import("../pages/Electricity"),
        },
        {
          path: "/dashboard/jamb",
          name: "jamb",
          component: () => import("../pages/Jamb"),
        },
        {
          path: "/dashboard/paybills",
          name: "paybills",
          component: () => import("../pages/PayBills"),
        },
        {
          path: "/dashboard/TransactionHistory",
          name: "transactionHistory",
          component: () => import("../pages/TransactionHistory"),
        },
        {
          path: "/dashboard/profile",
          name: "profile",
          component: () => import("../pages/ProfileDetail"),
        },
        {
          path: "/dashboard/changepin",
          name: "changepin",
          component: () => import("../pages/ChangePin"),
        },
        {
          path: "/dashboard/CustomerServices",
          name: "CustomerServices",
          component: () => import("../pages/CustomerServices"),
        },
      ],
    },
    {
      path: "/Successful",
      name: "Successful",
      meta: { forAuth: true },
      component: () => import("../pages/Successful"),
    },
    {
      path: "*",
      name: "page404",
      component: () => import("../pages/Page404"),
    },
  ],
});
